// istanbul ignore file
/**
 * Imports FindOrCreateModule from shared-ui
 */
import type { FindOrCreateProps } from '@makemydeal/dr-sales-checkin-types';
import { createRemoteModule } from '@makemydeal/dr-shared-components';
import type { FunctionComponent } from 'react';

export const FindOrCreateModule: FunctionComponent<FindOrCreateProps> = createRemoteModule<FindOrCreateProps>(
    'customer',
    './FindOrCreateModule'
);
